import { Card, Illustration, Text, type UseModalState } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib";

import { BottomSheetHeader } from "../components/BottomSheetHeader";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";

interface HolidayGiftInstructionsBottomSheetProps {
  modalState: UseModalState;
  userEmail: string;
  onBack: () => void;
  onClose: () => void;
}

// eslint-disable-next-line no-restricted-syntax
const instructionsIndexBackgroundColor = "#CFE8FF";
// eslint-disable-next-line no-restricted-syntax
const instructionIndexTextColor = "#091D82";

export function HolidayGiftInstructionsBottomSheet(props: HolidayGiftInstructionsBottomSheetProps) {
  const { modalState, userEmail, onClose, onBack } = props;

  const instructions = [
    "Click on the link in your inbox. Make sure to check your spam!",
    "Enter your shipping information and complete the order.",
    "Your free jacket will be delivered directly to you!",
  ];

  return (
    <FullScreenDialog
      modalState={modalState}
      variant="tertiary"
      PaperProps={{
        sx: {
          background:
            "linear-gradient(180deg, rgba(251, 242, 232, 1) 0%, rgba(218, 241, 232, 1) 100%)",
          overflow: "hidden",
        },
      }}
    >
      <BottomSheetHeader onClose={onClose} />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack
          spacing={9}
          sx={{
            paddingTop: 7,
            paddingX: 7,
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Illustration type="mail-person" />

          <Stack spacing={5}>
            <Text variant="h3" textAlign="center" px={4}>
              We&apos;ve emailed you a custom link!
            </Text>

            <Text variant="body2" textAlign="center">
              Sent to:{" "}
              <Text inline bold variant="body2" textAlign="center">
                {userEmail}
              </Text>
            </Text>
          </Stack>

          <Card variant="tertiary">
            <Stack spacing={5} paddingX={5} paddingY={6}>
              {instructions.map((instruction, index) => (
                <Stack
                  // oxlint-disable-next-line react/no-array-index-key -- Static array with no unique IDs
                  key={`instruction-${index + 1}`}
                  direction="row"
                  spacing={5}
                  alignItems="center"
                >
                  <Box
                    sx={(theme) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: theme.spacing(7),
                      minHeight: theme.spacing(7),
                      borderRadius: theme.spacing(7),
                      backgroundColor: instructionsIndexBackgroundColor,
                    })}
                  >
                    <Text bold variant="body1" color={instructionIndexTextColor}>
                      {index + 1}
                    </Text>
                  </Box>
                  <Text semibold variant="body1" textAlign="left">
                    {instruction}
                  </Text>
                </Stack>
              ))}
            </Stack>
          </Card>
        </Stack>
      </Box>
      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onBack}>
          Got it!
        </Button>
      </DialogFooter>
    </FullScreenDialog>
  );
}
